import { gql } from '@apollo/client'
import { GET_BANNERS_DATA } from 'src/actions'
import { getTimeWithoutTimezone } from 'src/services'
import { dispatchQueryGQL } from '../../gqlActions'

const GET_BANNERS = gql`
  query GetBanners($dateNow: Float!) {
    getBanners(dateNow: $dateNow) {
      sort
      background
      backgroundColor
      buttonOptions {
        color
        text
        variant
      }
      contentOptions {
        color
        variant
      }
      contentText
      creation_date
      end_date
      link
      start_date
      title
      titleOptions {
        color
        variant
      }
      type
    }
  }
`
export const getBannersGQL = () => {
  return dispatchQueryGQL({
    query: GET_BANNERS,
    variables: { dateNow: getTimeWithoutTimezone() },
    type: GET_BANNERS_DATA,
    key: 'getBanners'
  })
}
